import { connect } from 'react-redux';
import moment from 'moment-timezone';

import {
  getActualizationDate,
  getAmountCalculatedDate,
  getProjectZoneId,
  sideMenuCollapsed,
} from '../../reducers/analyticsApp';
import ActualizationDate from '../../components/navigation/ActualizationDate';
import { checkActualization } from '../../actions/project';
import { DEFAULT_DATA } from '../../constants/common';

const formatDate = (actualizationDate, zoneId) =>
  moment(actualizationDate).tz(zoneId).format('YYYY-MM-DD HH:mm:ss');

const mapStateToProps = (state) => {
  const actualizationDate = getActualizationDate(state);
  const amountCalculatedDate = getAmountCalculatedDate(state);

  return {
    actualizationDate:
      !!actualizationDate && actualizationDate !== DEFAULT_DATA
        ? formatDate(getActualizationDate(state), getProjectZoneId(state))
        : DEFAULT_DATA,
    amountCalculatedDate:
      !!amountCalculatedDate && amountCalculatedDate !== DEFAULT_DATA
        ? formatDate(getAmountCalculatedDate(state), getProjectZoneId(state))
        : DEFAULT_DATA,
    projectZone: getProjectZoneId(state),
    sideMenuCollapsed: sideMenuCollapsed(state),
  };
};

const mapDispatchToProps = {
  checkActualization,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActualizationDate);
